/**
 * Strategem target anchoring helpers — prevent phantom orbs/explosions on empty/wrong slots.
 */

/** Returned by getTargetPixelPosition when a unit target cannot be resolved (do not fly orb / burst). */
export const INVALID_STRATEGEM_TARGET_PIXEL = Object.freeze({ x: 0, y: 0, invalid: true });

export function isInvalidStrategemTargetPixel(pos) {
  return pos != null && pos.invalid === true;
}

export function isUnusableStrategemTargetPixel(pos) {
  return isInvalidStrategemTargetPixel(pos) || (pos != null && pos.x === 0 && pos.y === 0);
}

/** Stable dedupe key for generalInteractions (must not use array index). */
export function buildGeneralInteractionDedupeKey(interaction) {
  return `${interaction.sourceId}-${interaction.sourceInstanceId}-${interaction.effectType}-${interaction.amount}-${interaction.interactionTurn}`;
}

function normalizeZoneWithPlayerPrefix(zone, playerId) {
  if (!zone) return zone;
  if (zone === 'front' || zone === 'flank') {
    const playerPrefix = playerId === 'opponent' ? 'opponent' : 'your';
    return `${playerPrefix}_${zone}`;
  }
  if (!zone.includes('_')) {
    const playerPrefix = playerId === 'opponent' ? 'opponent' : 'your';
    return `${playerPrefix}_${zone}`;
  }
  return zone;
}

/**
 * True when the slot shows a deployed unit card (or instanceId exists anywhere on the board).
 */
export function slotHasVisibleDeployedUnit(zone, index, instanceId = null) {
  if (typeof document === 'undefined') {
    return true;
  }

  if (instanceId != null && instanceId !== '') {
    const suffix = `_${String(instanceId)}`;
    const nodes = document.querySelectorAll('[data-unit-key]');
    for (let i = 0; i < nodes.length; i++) {
      const key = nodes[i].getAttribute('data-unit-key') || '';
      if (key.endsWith(suffix)) {
        const art =
          nodes[i].querySelector('.order-design-card-bounds') ||
          nodes[i].querySelector('.order-design-minimal');
        if (art) {
          const rect = art.getBoundingClientRect();
          if (rect.width >= 2 && rect.height >= 2) return true;
        }
      }
    }
    return false;
  }

  if (zone == null || index == null || index === undefined) {
    return false;
  }

  const normalizedZone = normalizeZoneWithPlayerPrefix(zone, zone.startsWith('opponent_') ? 'opponent' : 'your');
  const idxStr = String(index);
  const art =
    document.querySelector(
      `.deployed-unit-slot[data-slot-zone="${normalizedZone}"][data-slot-index="${idxStr}"] .order-design-card-bounds`
    ) ||
    document.querySelector(
      `[data-slot-zone="${normalizedZone}"][data-slot-index="${idxStr}"] .order-design-card-bounds`
    );
  if (!art) {
    return false;
  }
  const rect = art.getBoundingClientRect();
  return rect.width >= 2 && rect.height >= 2;
}

export function invalidStrategemTargetPixel(reason) {
  if (reason) {
    console.warn(`⚠️ StrategemTargetAnimation: invalid unit target — ${reason}`);
  }
  return { ...INVALID_STRATEGEM_TARGET_PIXEL };
}
